import styled from "styled-components";
import Image from "next/image";
import Button from "./Button";

import logo from "../../../public/images/logo-fotop.png";

const Container = styled.header`
    background: #0D0D0D;

    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 88px;
        padding: 0 15px;
    }

    @media (max-width: 540px) {
        .break-mobile {
            display: block;
        }
    }
`;

const Header = () => {
    return (
        <Container>
            <div className="container">
                <a href="/" title="Fotop - Ir para página inicial">
                    <Image src={logo} alt="Fotop" priority />
                    {/*<img src="/images/logo-fotop.png" alt="Fotop" />*/}
                </a>

                <Button dark href="#orcamento">
                    <span className="break-mobile">Solicite um </span>orçamento
                </Button>
            </div>

        </Container>
    );
};

export default Header;
